import { render, staticRenderFns } from "./comp_dpc-4BannersPlusSlide.vue?vue&type=template&id=45664d8e&scoped=true"
import script from "./comp_dpc-4BannersPlusSlide.vue?vue&type=script&lang=js"
export * from "./comp_dpc-4BannersPlusSlide.vue?vue&type=script&lang=js"
import style0 from "./comp_dpc-4BannersPlusSlide.vue?vue&type=style&index=0&id=45664d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45664d8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
